import { Box, Typography } from '@mui/material';
import { GridColDef } from '@mui/x-data-grid';
import { UPDataGrid } from 'components/data-grid';
import { UPDataGridContainer } from 'modules/companies/payroll/wage-exemptions/styles';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  COMPANY__COMPANY,
  GENERAL__NAME,
  REPORTING__DOCUMENT_FOLLOW_UP_NO_EMPLOYEES,
  REPORTING__DOCUMENT_FOLLOW_UP_STATUS,
  REPORTING__DOCUMENT_VALIDITY_END,
  REPORTING__DOCUMENT_VALIDITY_START,
  REPORTING__UPLOADED_BY,
  REPORTING__UPLOADED_DATE,
} from 'translations/constants';
import DocumentFollowUpData from 'types/reporting/DocumentFollowUpData';

const formatDateCell = (value: string): string => {
  if (!value) return '';

  const date = new Date(value);
  const month = `${date.getMonth() + 1}`.padStart(2, '0');
  const day = `${date.getDate()}`.padStart(2, '0');

  return [date.getFullYear(), month, day].join('-');
};

const DocumentFollowUpReport = (props: { items: DocumentFollowUpData[]; hasGenerated: boolean }) => {
  const { items, hasGenerated } = props;
  const [t] = useTranslation();

  const [, setRowOnHover] = useState<number>();

  const columnDef: GridColDef[] = [
    { field: 'companyId', headerName: '', hide: true },
    { field: 'employeeId', headerName: '', hide: true },
    {
      field: 'companyName',
      headerName: t(COMPANY__COMPANY),
      width: 250,
      headerAlign: 'center',
      align: 'center',
    },
    {
      field: 'employeeName',
      headerName: t(GENERAL__NAME),
      width: 250,
      headerAlign: 'center',
      align: 'center',
    },
    {
      field: 'documentValidityStartDate',
      headerName: t(REPORTING__DOCUMENT_VALIDITY_START),
      width: 180,
      headerAlign: 'center',
      align: 'center',
      valueFormatter: params => formatDateCell(params.value as string),
    },
    {
      field: 'documentValidityEndDate',
      headerName: t(REPORTING__DOCUMENT_VALIDITY_END),
      width: 180,
      headerAlign: 'center',
      align: 'center',
      valueFormatter: params => formatDateCell(params.value as string),
    },
    {
      field: 'uploadedDate',
      headerName: t(REPORTING__UPLOADED_DATE),
      width: 180,
      headerAlign: 'center',
      align: 'center',
      valueFormatter: params => formatDateCell(params.value as string),
    },
    {
      field: 'uploadedBy',
      headerName: t(REPORTING__UPLOADED_BY),
      width: 220,
      headerAlign: 'center',
      align: 'center',
    },
    {
      field: 'statusTranslationKey',
      headerName: t(REPORTING__DOCUMENT_FOLLOW_UP_STATUS),
      width: 150,
      headerAlign: 'center',
      align: 'center',
      valueGetter: params => t(params.row.statusTranslationKey),
    },
  ];

  if (hasGenerated && items.length === 0) {
    return (
      <Box sx={{ padding: '24px', textAlign: 'center' }}>
        <Typography>{t(REPORTING__DOCUMENT_FOLLOW_UP_NO_EMPLOYEES)}</Typography>
      </Box>
    );
  }

  return (
    <Box>
      <UPDataGridContainer sx={{ height: '70vh' }}>
        <UPDataGrid
          rows={items}
          columns={columnDef}
          withCheckboxes={false}
          setRowOnHover={setRowOnHover}
          getRowId={r => `document_follow_up_${r.companyId}_${r.employeeId}`}
        />
      </UPDataGridContainer>
    </Box>
  );
};

export default DocumentFollowUpReport;
